<template>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 mx-auto form p-1">
            <div v-if="payload" class="alert alert-success" role="alert">
                Дані успішно збережені!
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                Помилка при збереженні даних
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label>
                            <strong>Название*</strong>
                        </label>
                        <input
                            name="title"
                            type="text"
                            v-model="model.title"
                            class="form-control"
                        >
                    </div>

                    <br>
                    <br>

                    <div class="form-group">
                        <label>
                            <strong>Позиция</strong>
                        </label>
                        <input
                            name="title"
                            type="text"
                            v-model="model.order"
                            class="form-control"
                        >
                    </div>

                    <br>
                    <br>

                    <div class="form-group">
                        <label>
                            <strong>Документ*</strong>
                        </label>
                        <input type="file"
                            @change="onChange"
                            ref="file1"
                        >
                        <a v-if="file" :href="file">{{ model.title ? model.title : 'File' }}</a>
                    </div>

                    <br>
                    <br>

                </div>
            </div>
            <div class="text-right">
                <template v-if="model.id">
                    <delete-confirmation
                        :route-path="route('api.busbar_docs.delete', {busbar_doc: model.id})"
                        :redirect-path="route('busbar.docs')"
                        :title="'Удаление'"
                        class="btn btn-danger mr-1 text-white"
                    >Удалить</delete-confirmation>
                </template>
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="update"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import FormHelper from './mixins/form_helper';

export default {
    props: {
        model: {
            type: Object,
            required: false,
        }
    },
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
    },
    mixins: [FormHelper],
    data() {
        return {
            errors: {},
            payload: false,
            error: false,
            file: null,
        }
    },
    mounted() {
        console.log(this.model);
    },
    methods: {
        update() {
            this.sendData = new FormData();
            this.collectFormData(this.model);

            this.payload = false;
            this.error = false;
            axios.post(this.route('api.busbar_docs.update', {busbar_doc: this.model.id}),
                this.sendData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then((result) => {
                    location.reload();

                    this.payload = true;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },
        onChange() {
            let file = this.$refs.file1.files[0];
            this.model.file = file;
            this.file = URL.createObjectURL(file);
        }
    },

    created() {
        if (this.model.id && this.model.url) {
            this.file = this.model.url;
            this.model.url = null;
        }
    }
}
</script>

<style scoped>
.file .pi {
    font-size: 24px;
}
.list li {
    list-style: none;
}
</style>